import Facebook from '../../src/legacy/Facebook.tsx';
export default Facebook;
